// Global Instructions Rule Applied!
import React from 'react'
import { useDispatch } from 'react-redux'
import { FormSection } from '../../../../../core/components/FormSection.tsx'
import { InputManager } from '../../../../../core/components/InputManager/index.ts'
import { updateDealRecord } from '../../../../../state_manager/state_update_actions/deals/index.ts'
import { DealFields } from '../../../../../state_manager/data_models/deal_record.ts'
import { getBusinessAddressFields } from '../../../utils/fieldConfigs.ts'

interface BusinessAddressSectionProps {
  formData?: any
  handleFieldChange?: (key: string, value: any) => void
  onPatchSuccess?: (patchRecordId: string, updates: Record<string, any>) => void
  isReadOnly?: boolean
  recordId?: string | number | null
  cardProps?: any
}

export function BusinessAddressSection({
  formData,
  handleFieldChange,
  onPatchSuccess,
  isReadOnly = false,
  recordId = null,
  cardProps = {}
}: BusinessAddressSectionProps) {
  const dispatch = useDispatch()

  const data = formData || {}

  const dealId = recordId || data[DealFields.deals__id] || data.id

  const accountId = data[DealFields.accounts__id] || data[DealFields.deals__account] || data.account_id

  const fieldOptions = {}

  const handlePatchSuccessLocal = (patchRecordId: string, updates: Record<string, any>) => {
    if (onPatchSuccess) {
      onPatchSuccess(patchRecordId, updates)
    } else {
      dispatch(updateDealRecord({ dealId: dealId, updates }))
    }
  }

  return (
    <FormSection
      data-debug='business-address-section'
      data-component='BusinessAddressSection'
      title='Business address'
      titleColor='blue'
      {...cardProps}
    >
      <div data-debug='business-address-section-content'>
        <InputManager
          inputMode='read'
          labelPosition='inline'
          fields={getBusinessAddressFields(data, fieldOptions, isReadOnly)}
          onChange={(key: string, value: any) => handleFieldChange?.(key, value)}
          enableAutoPatch={!isReadOnly && !!accountId}
          patchId={accountId}
          recordId={dealId}
          onPatchSuccess={handlePatchSuccessLocal}
          className='business-address-section-fields'
        />
      </div>
    </FormSection>
  )
}
